import React from 'react';
import { useSelector } from 'react-redux';

import cx from '@travel/icons/_utils/classnames';
import { Translate } from '@travel/translation';
import { DESKTOP_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';

import { getItem } from 'store/banner/selectors';

import styles from './banner.module.scss';

type Props = { className?: string };

function Banner(props: Props) {
  const isPC = useDeviceType() === DESKTOP_SCREEN;
  const item = useSelector(getItem);

  // Don't render if banner data isn't loaded yet (prevents hydration mismatch)
  const imageSrc = isPC ? item.titleImagePc : item.titleImageSp;
  if (!item.titleBackgroundColor || !imageSrc) {
    return null;
  }

  return (
    <div className={cx(props.className, styles.wrapper)} data-testid="banner-wrapper">
      <div
        className={styles.backgroundContainer}
        style={{ '--banner-bg-color': item.titleBackgroundColor } as React.CSSProperties}
      >
        <div className={styles.contentContainer}>
          <p className={styles.title}>{<Translate id="Booking_List.Header.Page_Title" />}</p>
          <img src={imageSrc} className={styles.image} alt="travel feeling" />
        </div>
      </div>
    </div>
  );
}

export default Banner;
